






import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import historyManager from "@/lib/historyManager";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "GoBack",
  components: { BaseIcon },
  props: {
    defaultRoute: { type: Object as () => Location | null, default: null },
  },
  methods: {
    onClick() {
      if (this.$listeners.click) {
        this.$emit("click");
      } else if (!historyManager.hasHistory() && this.defaultRoute) {
        this.$router.push(this.defaultRoute);
      } else {
        this.$router.back();
      }
    },
  },
});
